// Generated by Melange

import * as $$BigInt from "./BigInt.mjs";
import * as Curry from "melange.js/curry.mjs";
import * as Stdlib__List from "melange/list.mjs";
import * as Stdlib__Option from "melange/option.mjs";
import * as Stdlib__String from "melange/string.mjs";

function char_text(c) {
  const json = JSON.stringify(c);
  return Stdlib__String.sub(json, 1, json.length - 2 | 0);
}

function anchor_text(param) {
  switch (param) {
    case /* BeginInput */ 0 :
      return "^";
    case /* EndInput */ 1 :
      return "$";
    case /* WordBoundary0 */ 2 :
      return "\\b";
    case /* NonWordBoundary */ 3 :
      return "\\B";
    case /* BeginBuffer */ 4 :
      return "\\A";
    case /* EndBuffer */ 5 :
      return "\\z";
    case /* TerminatedBuffer */ 6 :
      return "\\Z";
  }
}

function cd_text(c) {
  if (/* tag */ typeof c === "number" || typeof c === "string") {
    switch (c) {
      case /* CdEmpty */ 0 :
        return "[]";
      case /* CdDot */ 1 :
        return ".";
      case /* CdAll */ 2 :
        return "·";
      case /* CdDigits */ 3 :
        return "\\d";
      case /* CdNonDigits */ 4 :
        return "\\D";
      case /* CdWhitespace */ 5 :
        return "\\s";
      case /* CdNonWhitespace */ 6 :
        return "\\S";
      case /* CdWordChar */ 7 :
        return "\\w";
      case /* CdNonWordChar */ 8 :
        return "\\W";
    }
  } else {
    switch (c.TAG) {
      case /* CdSingle */ 0 :
        return char_text(c._0);
      case /* CdUnicodeProp */ 1 :
        return "\\p";
      case /* CdNonUnicodeProp */ 2 :
        return "\\P";
      case /* CdInv */ 3 :
        return "[^" + (class_body(c._0) + "]");
      case /* CdRange */ 4 :
      case /* CdUnion */ 5 :
        return "[" + (class_body(c) + "]");
    }
  }
}

function class_body(cd) {
  if (/* tag */ typeof cd === "number" || typeof cd === "string") {
    if (cd === /* CdEmpty */ 0) {
      return "";
    } else {
      return cd_text(cd);
    }
  }
  switch (cd.TAG) {
    case /* CdRange */ 4 :
      return char_text(cd._0) + ("-" + char_text(cd._1));
    case /* CdUnion */ 5 :
      return class_body(cd._0) + class_body(cd._1);
    default:
      return cd_text(cd);
  }
}

function quant_suffix(greedy, mn, delta) {
  const mn$1 = $$BigInt.to_int(mn);
  let delta$1;
  delta$1 = /* tag */ typeof delta === "number" || typeof delta === "string" ? undefined : $$BigInt.to_int(delta._0);
  let base;
  let exit = 0;
  if (mn$1 !== 0) {
    if (mn$1 !== 1 || delta$1 !== undefined) {
      exit = 1;
    } else {
      base = "+";
    }
  } else if (delta$1 !== undefined) {
    if (delta$1 !== 1) {
      exit = 1;
    } else {
      base = "?";
    }
  } else {
    base = "*";
  }
  if (exit === 1) {
    base = delta$1 !== undefined ? (
        delta$1 !== 0 ? "{" + (String(mn$1) + ("," + (String(mn$1 + delta$1 | 0) + "}"))) : "{" + (String(mn$1) + "}")
      ) : "{" + (String(mn$1) + ",}");
  }
  const suffix = greedy ? "" : "?";
  return base + suffix;
}

function lk_marker(param) {
  switch (param) {
    case /* LookAhead */ 0 :
      return "=";
    case /* LookBehind */ 1 :
      return "<=";
    case /* NegLookAhead */ 2 :
      return "!";
    case /* NegLookBehind */ 3 :
      return "<!";
  }
}

const Pp = {
  char_text: char_text,
  anchor_text: anchor_text,
  cd_text: cd_text,
  class_body: class_body,
  quant_suffix: quant_suffix,
  lk_marker: lk_marker
};

function text(parent, t) {
  parent.appendChild(document.createTextNode(t));
}

function el(cls, attrsOpt, txt, tag) {
  const attrs = attrsOpt !== undefined ? attrsOpt : /* [] */ 0;
  const e = document.createElement(tag);
  Stdlib__Option.iter((function (param) {
    e.className = param;
  }), cls);
  Stdlib__List.iter((function (param) {
    e.setAttribute(param[0], param[1]);
  }), attrs);
  Stdlib__Option.iter((function (param) {
    return text(e, param);
  }), txt);
  return e;
}

function rx_span(id) {
  return el("rx", {
    hd: [
      "data-regex-id",
      String(id)
    ],
    tl: /* [] */ 0
  }, undefined, "span");
}

function subscript(parent, t) {
  parent.appendChild(el(undefined, undefined, t, "sub"));
}

const Html = {
  text: text,
  el: el,
  rx_span: rx_span,
  subscript: subscript
};

function levelOf(param) {
  if (/* tag */ typeof param === "number" || typeof param === "string") {
    return 3;
  }
  switch (param.TAG) {
    case /* Disjunction0 */ 1 :
      return 0;
    case /* Sequence */ 2 :
      return 1;
    case /* Quantified0 */ 3 :
      return 2;
    default:
      return 3;
  }
}

function needs_parens(strict, parent, child) {
  if (/* tag */ typeof parent === "number" || typeof parent === "string") {
    return false;
  }
  switch (parent.TAG) {
    case /* Disjunction0 */ 1 :
    case /* Sequence */ 2 :
    case /* Quantified0 */ 3 :
      break;
    default:
      return false;
  }
  if (strict) {
    return levelOf(child) <= levelOf(parent);
  } else {
    return levelOf(child) < levelOf(parent);
  }
}

const Prec = {
  levelOf: levelOf,
  needs_parens: needs_parens
};

function render_regex(root, target, idMap, onHover) {
  const lastId = {
    contents: 0
  };
  const render_subregex = function (wrap, r, parent) {
    const firstId = Stdlib__List.assq(r, idMap);
    lastId.contents = firstId;
    const span = rx_span(firstId);
    if (wrap) {
      text(span, "⟨");
    }
    render_into(span, r);
    if (wrap) {
      text(span, "⟩");
    }
    const lastId$1 = lastId.contents;
    span.addEventListener("mouseover", (function (e) {
      Curry._2(onHover, {
        first: firstId,
        last: lastId$1
      }, e);
    }));
    parent.appendChild(span);
  };
  const render_into = function (span, r) {
    const nested = function (strict, r1) {
      render_subregex(needs_parens(strict, r, r1), r1, span);
    };
    if (/* tag */ typeof r === "number" || typeof r === "string") {
      return text(span, "𝜀");
    }
    switch (r.TAG) {
      case /* Character */ 0 :
        return text(span, cd_text(r._0));
      case /* Disjunction0 */ 1 :
        nested(false, r._0);
        text(span, "|");
        return nested(true, r._1);
      case /* Sequence */ 2 :
        nested(false, r._0);
        return nested(true, r._1);
      case /* Quantified0 */ 3 :
        nested(true, r._3);
        return text(span, quant_suffix(r._0, r._1, r._2));
      case /* Lookaround */ 4 :
        text(span, "(?" + lk_marker(r._0));
        nested(false, r._1);
        return text(span, ")");
      case /* Group0 */ 5 :
        text(span, "(");
        subscript(span, $$BigInt.to_string(r._0));
        nested(false, r._1);
        return text(span, ")");
      case /* Anchor */ 6 :
        return text(span, anchor_text(r._0));
      case /* Backreference */ 7 :
        return text(span, "\\" + $$BigInt.to_string(r._0));
    }
  };
  render_subregex(false, root, target);
  target.addEventListener("mouseleave", (function (e) {
    Curry._2(onHover, null, e);
  }));
}

export {
  Pp,
  Html,
  Prec,
  render_regex,
}
/* BigInt Not a pure module */
